var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.entryComponent,{tag:"component",on:{"success":function($event){return _vm.$emit('success')},"back":function($event){return _vm.$emit('back')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }